import { TYPE_INSTANCE2 } from "App/constants";
import { fetchData } from "App/utils/helpers";
import { useState, useEffect } from "react";

function useTarifAsHeadCells(headCells, addOptionalCells = []) {
  const [newHeadCells, setNewHeadCells] = useState(headCells);
  const [headTarif, setHeadTarif] = useState([]);

  const setTarif = async () => {
    const response = await fetchData(
      TYPE_INSTANCE2,
      "/kelaskunjungan/listtarif"
    );
    const newHead = await newTarif(response);
    setHeadTarif(newHead);
    setNewHeadCells([...headCells, ...newHead, ...addOptionalCells]);
  };

  useEffect(() => {
    setTarif();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const newTarif = async (arr) => {
    const _temp = [];
    await arr.map((item) =>
      _temp.push({
        id: `${item.name}`,
        disablePadding: false,
        label: item.name,
        align: "right",
        sort: false,
        minWidth: "150px",
        maskID: item.id,
      })
    );
    return _temp;
  };


  return {
    newHeadCells,
    headTarif,
  };
}

export default useTarifAsHeadCells;
